import { render, staticRenderFns } from "./nuevaPoliza.vue?vue&type=template&id=39bbf118&"
import script from "./nuevaPoliza.vue?vue&type=script&lang=js&"
export * from "./nuevaPoliza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports